/*
 * @Author: Tahiti
 * @Date: 2025-12-03 15:01:29
 * @LastEditors: Tahiti
 * @LastEditTime: 2026-01-06 22:32:59
 * @Description:
 * @FilePath: /weryai-web/locales/modules/order_modal.ts
 */
export default {
    zh: {
        '1-1': '绑定Discord',
        3603: '该Mate账号已绑定，请更换账号后重试',
        200: '绑定成功，返回App领取奖励',
        3606: 'Discord账号已绑定，请更换账号后重试',
        500: '绑定失败请重试',
        '1-6': '返回领取奖励',
        socialBack: '分享有礼',
        socialBackDescription:
            '分享有礼，邀请好友注册WeryAI，您和好友都能获得奖励。',
        bg_color: '背景颜色',
    },
    en: {
        '1-1': 'Bind Discord',
        '3603': 'The Mate account has already been bound, please try again with a different account',
        '200': 'Binding successful, return to the app to claim rewards',
        '3606': 'Discord account has already been bound, please try again with a different account',
        '500': 'Binding failed, please try again',
        '1-6': 'Return to claim rewards',
        socialBack: 'Share with friends',
        socialBackDescription:
            'Share with friends, invite friends to register WeryAI, you and your friends can get rewards.',
        bg_color: 'Background Color',
    },
    ja: {
        '1-1': 'Discordをバインド',
        '3603': 'すでにMateアカウントがバインドされています。別のアカウントで再度お試しください。',
        '200': 'バインド成功、アプリに戻って報酬を受け取ります',
        '3606': 'Discordアカウントがすでにバインドされています。別のアカウントで再度お試しください。',
        '500': 'バインドに失敗しました。再度お試しください。',
        '1-6': '報酬を受け取るためにアプリに戻ります',
        socialBack: '友達と共有',
        socialBackDescription:
            '友達と共有し、友達にWeryAIを登録してもらうと、あなたと友達は報酬を受け取れます。',
        bg_color: '背景色',
    },
    ko: {
        '1-1': 'Discord 바인딩',
        '3603': '이미 Mate 계정이 바인딩되어 있습니다. 다른 계정으로 다시 시도하세요.',
        '200': '바인딩 성공, 앱으로 돌아가서 보상을 받으세요',
        '3606': 'Discord 계정이 이미 바인딩되어 있습니다. 다른 계정으로 다시 시도하세요.',
        '500': '바인딩 실패, 다시 시도하세요',
        '1-6': '보상을 받으려면 앱으로 돌아가세요',
        socialBack: '친구와 공유',
        socialBackDescription:
            '친구와 공유하여 WeryAI를 등록하면 보상을 받을 수 있습니다.',
        bg_color: '배경색',
    },
    tw: {
        '1-1': 'Discord 綁定',
        '3603': '已綁定 Mate 帳號，請更換帳號後重試',
        '200': '綁定成功，返回App領取獎勵',
        '3606': '已綁定 Discord 帳號，請更換帳號後重試',
        '500': '綁定失敗，請重試',
        '1-6': '返回領取獎勵',
        socialBack: '分享給朋友',
        socialBackDescription:
            '分享給朋友，邀請朋友註冊WeryAI，您和朋友都能獲得獎勵。',
        bg_color: '背景顏色',
    },
    pl: {
        '1-1': 'Powiąż Discord',
        '3603': 'Konto Mate jest już powiązane, spróbuj ponownie z innym kontem',
        '200': 'Powiązanie zakończone, powróć do aplikacji, aby otrzymać nagrody',
        '3606': 'Konto Discord jest już powiązane, spróbuj ponownie z innym kontem',
        '500': 'Powiązanie nie powiodło się, spróbuj ponownie',
        '1-6': 'Powróć, aby otrzymać nagrody',
        socialBack: 'Podziel się z przyjaciółmi',
        socialBackDescription:
            'Podziel się z przyjaciółmi, zaprosz przyjaciół do rejestracji WeryAI, ty i twoi przyjaciele otrzymają nagrody.',
        bg_color: 'Kolor tła',
    },
    es: {
        '1-1': 'Vincular Discord',
        '3603': 'La cuenta Mate ya está vinculada, intente nuevamente con una cuenta diferente',
        '200': 'Vinculación exitosa, regrese a la aplicación para reclamar recompensas',
        '3606': 'La cuenta Discord ya está vinculada, intente nuevamente con una cuenta diferente',
        '500': 'Vinculación fallida, intente nuevamente',
        '1-6': 'Regresar para reclamar recompensas',
        socialBack: 'Compartir con amigos',
        socialBackDescription:
            'Compartir con amigos, invita a amigos a registrarse en WeryAI, tú y tus amigos recibirán recompensas.',
        bg_color: 'Color de fondo',
    },
    fr: {
        '1-1': 'Lier Discord',
        '3603': 'Le compte Mate est déjà lié, veuillez réessayer avec un compte différent',
        '200': "Liaison réussie, retournez à l'application pour réclamer les récompenses",
        '3606': 'Le compte Discord est déjà lié, veuillez réessayer avec un compte différent',
        '500': 'Liaison échouée, veuillez réessayer',
        '1-6': 'Retourner pour réclamer les récompenses',
        socialBack: 'Partager avec les amis',
        socialBackDescription:
            "Partager avec les amis, invitez les amis à s'inscrire sur WeryAI, vous et vos amis recevrez des récompenses.",
        bg_color: 'Couleur de fond',
    },
    de: {
        '1-1': 'Discord verbinden',
        '3603': 'Das Mate-Konto ist bereits verbunden, bitte versuchen Sie es mit einem anderen Konto erneut',
        '200': 'Verbindung erfolgreich, zurück zur App, um Belohnungen zu beanspruchen',
        '3606': 'Das Discord-Konto ist bereits verbunden, bitte versuchen Sie es mit einem anderen Konto erneut',
        '500': 'Verbindung fehlgeschlagen, bitte versuchen Sie es erneut',
        '1-6': 'Zurück zur App, um Belohnungen zu beanspruchen',
        socialBack: 'Mit Freunden teilen',
        socialBackDescription:
            'Teilen Sie mit Freunden, lade Freunde ein, sich bei WeryAI zu registrieren, Sie und Ihre Freunde erhalten Belohnungen.',
        bg_color: 'Hintergrundfarbe',
    },
    ru: {
        '1-1': 'Связать Discord',
        '3603': 'Учетная запись Mate уже связана, попробуйте снова с другим аккаунтом',
        '200': 'Связь успешно, вернитесь в приложение, чтобы получить награды',
        '3606': 'Учетная запись Discord уже связана, попробуйте снова с другим аккаунтом',
        '500': 'Связь не удалась, попробуйте снова',
        '1-6': 'Вернуться в приложение, чтобы получить награды',
        socialBack: 'Поделиться с друзьями',
        socialBackDescription:
            'Поделиться с друзьями, пригласите друзей зарегистрироваться в WeryAI, вы и ваши друзья получите награды.',
        bg_color: 'Цвет фона',
    },
    pt: {
        '1-1': 'Vincular Discord',
        '3603': 'A conta Mate já está vinculada, tente novamente com uma conta diferente',
        '200': 'Vinculação bem-sucedida, retorne à aplicação para reivindicar recompensas',
        '3606': 'A conta Discord já está vinculada, tente novamente com uma conta diferente',
        '500': 'Vinculação falhou, tente novamente',
        '1-6': 'Retorne à aplicação para reivindicar recompensas',
        socialBack: 'Compartilhar com amigos',
        socialBackDescription:
            'Compartilhar com amigos, convide amigos para se registrar no WeryAI, você e seus amigos receberão recompensas.',
        bg_color: 'Cor de fundo',
    },
    it: {
        '1-1': 'Collegare Discord',
        '3603': 'Il conto Mate è già collegato, prova di nuovo con un account diverso',
        '200': "Collegamento riuscito, ritorna all'applicazione per reclamare le ricompense",
        '3606': 'Il conto Discord è già collegato, prova di nuovo con un account diverso',
        '500': 'Collegamento fallito, prova di nuovo',
        '1-6': "Ritorna all'applicazione per reclamare le ricompense",
        socialBack: 'Condividi con amici',
        socialBackDescription:
            'Condividi con amici, invita amici a registrarsi su WeryAI, tu e i tuoi amici riceveranno ricompense.',
        bg_color: 'Colore di sfondo',
    },
    ar: {
        '1-1': 'ربط Discord',
        '3603': 'الحساب Mate مرتبط بالفعل، يرجى المحاولة مرة أخرى بحساب مختلف',
        '200': 'الربط ناجح، عد إلى التطبيق للاستلام المكافئات',
        '3606': 'الحساب Discord مرتبط بالفعل، يرجى المحاولة مرة أخرى بحساب مختلف',
        '500': 'الربط فشل، يرجى المحاولة مرة أخرى',
        '1-6': 'عد إلى التطبيق للاستلام المكافئات',
        socialBack: 'شارك مع الأصدقاء',
        socialBackDescription:
            'شارك مع الأصدقاء، إحضر أصدقائك لتسجيل WeryAI، ستحصل على مكافئات.',
        bg_color: 'لون الخلفية',
    },
    th: {
        '1-1': 'เชื่อม Discord',
        '3603': 'บัญชี Mate ถูกเชื่อมอยู่แล้ว กรุณาลองอีกครั้งด้วยบัญชีอื่น',
        '200': 'เชื่อมสำเร็จ กลับไปยังแอปเพื่อรับรางวัล',
        '3606': 'บัญชี Discord ถูกเชื่อมอยู่แล้ว กรุณาลองอีกครั้งด้วยบัญชีอื่น',
        '500': 'เชื่อมล้มเหลว กรุณาลองอีกครั้ง',
        '1-6': 'กลับไปยังแอปเพื่อรับรางวัล',
        socialBack: 'แชร์กับเพื่อน',
        socialBackDescription:
            'แชร์กับเพื่อน เชิญเพื่อนให้สมัคร WeryAI คุณและเพื่อนของคุณจะได้รับรางวัล',
        bg_color: 'สีพื้นหลัง',
    },
    da: {
        '1-1': 'Forbind Discord',
        '3603': 'Mate-kontoen er allerede forbundet, prøv igen med et andet konto',
        '200': 'Forbindelse lykkedes, vend tilbage til appen for at modtage belønninger',
        '3606': 'Discord-kontoen er allerede forbundet, prøv igen med et andet konto',
        '500': 'Forbindelse mislykkedes, prøv igen',
        '1-6': 'Vend tilbage til appen for at modtage belønninger',
        socialBack: 'Del med venner',
        socialBackDescription:
            'Del med venner, invite venner til at registrere sig på WeryAI, du og dine venner modtager belønninger.',
        bg_color: 'Baggrundsfarve',
    },
    no: {
        '1-1': 'Forbind Discord',
        '3603': 'Mate-kontoen er allerede forbundet, prøv igen med et andet konto',
        '200': 'Forbindelse lykkedes, vend tilbage til appen for at modtage belønninger',
        '3606': 'Discord-kontoen er allerede forbundet, prøv igen med et andet konto',
        '500': 'Forbindelse mislykkedes, prøv igen',
        '1-6': 'Vend tilbage til appen for at modtage belønninger',
        socialBack: 'Del med venner',
        socialBackDescription:
            'Del med venner, invite venner til at registrere sig på WeryAI, du og dine venner modtager belønninger.',
        bg_color: 'Baggrundsfarve',
    },
    nl: {
        '1-1': 'Discord verbinden',
        '3603': 'Mate-kontoen is al verbonden, probeer het opnieuw met een ander account',
        '200': 'Verbinding succesvol, terug naar de app om beloningen te claimen',
        '3606': 'Discord-kontoen is al verbonden, probeer het opnieuw met een ander account',
        '500': 'Verbinding mislukt, probeer het opnieuw',
        '1-6': 'Terug naar de app om beloningen te claimen',
        socialBack: 'Del met vrienden',
        socialBackDescription:
            'Del met vrienden, inviteer vrienden om zich te registreren bij WeryAI, jij en je vrienden ontvangen beloningen.',
        bg_color: 'Achtergrondkleur',
    },
    id: {
        '1-1': 'Menyambungkan Discord',
        '3603': 'Akun Mate sudah terhubung, silakan coba lagi dengan akun lain',
        '200': 'Penyambungan berhasil, kembali ke aplikasi untuk menerima hadiah',
        '3606': 'Akun Discord sudah terhubung, silakan coba lagi dengan akun lain',
        '500': 'Penyambungan gagal, silakan coba lagi',
        '1-6': 'Kembali ke aplikasi untuk menerima hadiah',
        socialBack: 'Bagikan dengan teman',
        socialBackDescription:
            'Bagikan dengan teman, undang teman untuk mendaftar di WeryAI, Anda dan teman Anda akan menerima hadiah.',
        bg_color: 'Warna latar belakang',
    },
    tr: {
        '1-1': 'Discord bağla',
        '3603': 'Mate hesabı zaten bağlı, lütfen başka bir hesap ile tekrar deneyin',
        '200': 'Bağlantı başarılı, uygulamaya dönüp ödüller alın',
        '3606': 'Discord hesabı zaten bağlı, lütfen başka bir hesap ile tekrar deneyin',
        '500': 'Bağlantı başarısız, lütfen tekrar deneyin',
        '1-6': 'Uygulamaya dönüp ödüller alın',
        socialBack: 'Arkadaşlarınla paylaş',
        socialBackDescription:
            "Arkadaşlarınla paylaş, arkadaşlarını WeryAI'ye kaydetmek için davet edin, siz ve arkadaşlarınız ödüller alın.",
        bg_color: 'Arkaplan rengi',
    },
}
